import { Modal, ModalWithTransition } from '@studiometa/ui';

/**
 * LightboxModal component
 * Fullscreen modal for displaying images with dark overlay
 */
export default class LightboxModal extends ModalWithTransition {
  static config = {
    name: 'LightboxModal',
    refs: [...Modal.config.refs],
    options: {
      styles: {
        type: Object,
        /**
         * @returns {ModalStylesOption}
         */
        default: () => ({
          modal: {
            closed: {
              opacity: '0',
              pointerEvents: 'none',
            },
            open: {
              opacity: '1',
              pointerEvents: 'auto',
            },
          },
          overlay: {
            closed: 'opacity-0',
          },
          container: {
            closed: 'opacity-0 scale-95',
          },
        }),
      },
    },
  };

  /**
   * Mounted hook - Move modal to body to escape stacking context
   */
  mounted() {
    super.mounted();

    if (this.$refs.modal) {
      document.body.append(this.$refs.modal);
    }
  }

  /**
   * Destroyed hook - Clean up
   */
  destroyed() {
    if (this.$refs.modal && this.$refs.modal.parentNode === document.body) {
      this.$refs.modal.remove();
    }

    super.destroyed();
  }
}
